export default "__VITE_ASSET__Cfqu25Hd__"